// src/store/slices/asistenciasSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AsistenciaService from 'services/AsistenciaService';

export const fetchAsistencias = createAsyncThunk(
    'asistencias/fetchAll',
    async (params, { rejectWithValue }) => {
        try {
            return await AsistenciaService.getAll(params);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al cargar asistencias');
        }
    }
);

export const createAsistenciaManual = createAsyncThunk(
    'asistencias/createManual',
    async (data, { rejectWithValue }) => {
        try {
            return await AsistenciaService.createManual(data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const updateAsistencia = createAsyncThunk(
    'asistencias/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            return await AsistenciaService.update(id, data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const deleteAsistencia = createAsyncThunk(
    'asistencias/delete',
    async (id, { rejectWithValue }) => {
        try {
            await AsistenciaService.remove(id);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al eliminar');
        }
    }
);

const asistenciasSlice = createSlice({
    name: 'asistencias',
    initialState: {
        list: [],
        pagination: { current: 1, pageSize: 15, total: 0 },
        loading: false,
        error: null,
    },
    reducers: {
        clearAsistenciasError: (state) => { state.error = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAsistencias.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchAsistencias.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload.data;
                state.pagination = {
                    current: action.payload.meta.current_page,
                    pageSize: action.payload.meta.per_page,
                    total: action.payload.meta.total,
                };
            })
            .addCase(fetchAsistencias.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateAsistencia.fulfilled, (state, action) => {
                const updated = action.payload.asistencia;
                if (updated) {
                    state.list = state.list.map((a) => (a.id === updated.id ? updated : a));
                }
            })
            .addCase(deleteAsistencia.fulfilled, (state, action) => {
                state.list = state.list.filter((a) => a.id !== action.payload);
            });
    },
});

export const { clearAsistenciasError } = asistenciasSlice.actions;
export default asistenciasSlice.reducer;
